// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"73":"d66efb","96":"bb990e","344":"293abc","662":"5da089","818":"233e81","933":"33f5bc"}[chunkId] + ".js";
};